const TZ = 'Pacific/Fiji';

export function fmtDate(v: string | null | undefined): string {
  if (!v) return '—';
  const d = v.length <= 10 ? new Date(v + 'T00:00:00') : new Date(v);
  if (Number.isNaN(d.getTime())) return v;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: v.length <= 10 ? undefined : TZ });
}

export function fmtDateTime(v: string | null | undefined): string {
  if (!v) return '—';
  const d = new Date(v);
  return d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: TZ });
}

export function fmtMoney(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—';
  const n = typeof v === 'string' ? Number(v) : v;
  if (Number.isNaN(n)) return String(v);
  return 'FJD ' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtBytes(n: number | null | undefined): string {
  if (!n && n !== 0) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export const STAGES: { value: string; label: string }[] = [
  { value: 'design', label: 'Design' },
  { value: 'mobilising', label: 'Mobilising' },
  { value: 'construction', label: 'Construction' },
  { value: 'handover', label: 'Handover' },
  { value: 'defects_liability', label: 'Defects liability' },
  { value: 'complete', label: 'Complete' },
  { value: 'on_hold', label: 'On hold' },
];

export function stageLabel(v: string): string {
  return STAGES.find((s) => s.value === v)?.label ?? v;
}

export const ORG_KINDS = ['client', 'contractor', 'architect', 'engineer', 'consultant', 'supplier', 'internal', 'finance', 'other'];

/** "a, b, c" → ["a","b","c"] */
export function splitList(s: string): string[] {
  return s
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
}
